module.exports = __webpack_public_path__ + "img/noTest.2929618a.svg";